#!/usr/bin/env node

import { runMain } from './run.js';

await runMain();
